module.exports = __webpack_public_path__ + "img/55.069314ce.jpg";